/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import LogoIndigo from '../../images/indigo_logo.svg';
import * as MATERIAL from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import * as API from '../../http/api';


const SecondaryMenu = (props) => {
    const [updateAny, setUpdateAny] = useState(false);
    const [listMenu, setListMenu] = useState({});
    const history = useHistory();

    let value_sort = obj => {
        let ret = {}
        Object.values(obj).sort()
            .forEach(val => {
                let key = Object.keys(obj).find(key => obj[key] == val)
                ret[key] = val
            })
        return ret
    }
    
    const init = async () => {
        props.changeLoader(true);
        let rol = JSON.parse(localStorage.session)['rol'] ? JSON.parse(localStorage.session)['rol'][0] : JSON.parse(localStorage.config)['idRol'];
        
        let request = await API.service('findMenus', {uuid: rol}, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == "OK") {
            let result = request.data.data.widget[0].content.secondary.in;
            let list = {}
            
            result.map((item) => {
                list[item.key] = item.name
            })
            setListMenu(list)
        }
        props.changeLoader(false);
    }

    useEffect(() => {
        setListMenu({})
        init()
    }, [])

    let secondaryMenuOrdered = value_sort(listMenu)

    const openSubMenu = (index) => {
        let cats = JSON.parse(localStorage.config)['secondaryMenu'];
        if (cats[index].hasOwnProperty('open')) {
            cats[index]['open'] = !cats[index]['open']
        } else {
            cats[index]['open'] = true;
        }

        let conf = JSON.parse(localStorage.config);
        conf['secondaryMenu'] = cats;
        localStorage.config = JSON.stringify(conf);
        setUpdateAny(!updateAny);
    }

    return <MATERIAL.SwipeableDrawer anchor="left" open={props.showSecondary} onOpen={props.openMenu.bind(this)} onClose={props.closeMenu.bind(this)}>
        <div>
            <img src={LogoIndigo} className="image-secondary" />
        </div>
        <MATERIAL.Divider />
        <MATERIAL.List>
            {
                localStorage.config && JSON.parse(localStorage.config)['collapsable'] && JSON.parse(localStorage.config)['secondaryMenu'].map((item, key) => {
                    return [
                        <MATERIAL.ListItemButton key={`secondMenu-collapse-${key}`} onClick={openSubMenu.bind(this, key)}>
                            <MATERIAL.ListItemText
                                primary={<span className="font-indigo">{item.label || "General"}</span>}
                            />
                            <MATERIAL.ListItemIcon>
                                {item.hasOwnProperty('open') && item['open'] ? <ExpandLess /> : <ExpandMore />}
                            </MATERIAL.ListItemIcon>
                        </MATERIAL.ListItemButton>,

                        <MATERIAL.Collapse in={item.hasOwnProperty('open') ? item['open'] : false} key={`collapse-${key}`}>
                            <MATERIAL.List component="div" disablePadding>
                                {
                                    item.hasOwnProperty('option') && Object.keys(secondaryMenuOrdered).map((item2, key2) => {
                                        if(item['option'].indexOf(item2) !== -1){
                                            return {
                                                [item2]: <MATERIAL.ListItem button key={`secondMenuCollapse-${key2}`} onClick={props.clickSecondary.bind(this, item2)}>
                                                    <MATERIAL.ListItemText
                                                        primary={
                                                            <span className="font-indigo">{secondaryMenuOrdered[item2]}</span>
                                                        }
                                                    />
                                                </MATERIAL.ListItem>
                                            }[item2]

                                        }
                                    })
                                }
                            </MATERIAL.List>
                        </MATERIAL.Collapse>
                    ]
                })
            }
            {
                localStorage.config && !JSON.parse(localStorage.config)['collapsable'] && JSON.parse(localStorage.config)['secondaryMenu'] && Object.keys(secondaryMenuOrdered).map((item, key) => {
                    if(JSON.parse(localStorage.config)['secondaryMenu'].indexOf(item) !== -1){
                        return {
                            [item]: <MATERIAL.ListItem button key={`secondMenu-${key}`} onClick={props.clickSecondary.bind(this, item)}>
                                <MATERIAL.ListItemText
                                    primary={
                                        <span className="font-indigo">{secondaryMenuOrdered[item]}</span>
                                    }
                                />
                            </MATERIAL.ListItem>
                        }[item]
                    }
                })

            }
            {
                localStorage.config && JSON.parse(localStorage.config)['admin'] &&
                <>
                    <MATERIAL.Divider />
                    <MATERIAL.ListItem button key={`secondMenu-1`} onClick={props.clickSecondary.bind(this, 'admin')}>
                        <MATERIAL.ListItemText
                            primary={
                                <span className="font-indigo">{'Administrador de agentes'}</span>
                            }
                        />
                    </MATERIAL.ListItem>
                    <MATERIAL.ListItem button key={`secondMenu-2`} onClick={props.clickSecondary.bind(this, 'adminRoles')} >
                        <MATERIAL.ListItemText
                            primary={
                                <span className="font-indigo">{'Administrador de roles'}</span>
                            }
                        />
                    </MATERIAL.ListItem>
                    <MATERIAL.ListItem button key={`secondMenu-3`} onClick={props.clickSecondary.bind(this, 'adminFactors')} >
                        <MATERIAL.ListItemText
                            primary={
                                <span className="font-indigo">{'Administrador de factores'}</span>
                            }
                        />
                    </MATERIAL.ListItem>
                    <MATERIAL.ListItem button key={`secondMenu-4`} onClick={props.clickSecondary.bind(this, 'adminUnits')} >
                        <MATERIAL.ListItemText
                            primary={
                                <span className="font-indigo">{'Administrador de grupos'}</span>
                            }
                        />
                    </MATERIAL.ListItem>
                </>
            }
            {
                localStorage.config && JSON.parse(localStorage.config)['script'] &&
                <>
                    <MATERIAL.Divider />
                    <MATERIAL.ListItem button key={`secondMenu-script`} onClick={props.clickSecondary.bind(this, 'adminScripts')}>
                        <MATERIAL.ListItemText
                            primary={
                                <span className="font-indigo">{'Administrador de scripts'}</span>
                            }
                        />
                    </MATERIAL.ListItem>
                </>
            }
            {
                localStorage.config && JSON.parse(localStorage.config)['features'] &&
                <>
                    <MATERIAL.ListItem button key={`secondMenu-features`} onClick={props.clickSecondary.bind(this, 'inextManagerFeatures')}>
                        <MATERIAL.ListItemText
                            primary={
                                <span className="font-indigo">{'Administrador de funciones'}</span>
                            }
                        />
                    </MATERIAL.ListItem>
                </>
            }
            {
                localStorage.config && JSON.parse(localStorage.config)['commissions'] &&
                <>
                    <MATERIAL.Divider />
                    <MATERIAL.ListItem button key={`secondMenu-commissions`} onClick={props.clickSecondary.bind(this, 'commissionCrmList')}>
                        <MATERIAL.ListItemText
                            primary={
                                <span className="font-indigo">{'Gestor de Comisiones'}</span>
                            }
                        />
                    </MATERIAL.ListItem>
                    <MATERIAL.ListItem button key={`secondMenu-sellers`} onClick={props.clickSecondary.bind(this, 'sellerCrmList')}>
                        <MATERIAL.ListItemText
                            primary={
                                <span className="font-indigo">{'Administrador de Vendedores'}</span>
                            }
                        />
                    </MATERIAL.ListItem>
                </>
            }
            {
                localStorage.config && JSON.parse(localStorage.config)['afbRecurringOps'] &&
                <>
                    <MATERIAL.Divider />
                    <MATERIAL.ListItem button key={`secondMenu-afbRecurringOps`} onClick={props.clickSecondary.bind(this, 'afbRecurringList')}>
                        <MATERIAL.ListItemText
                            primary={
                                <span className="font-indigo">{'Operaciones Recurrentes'}</span>
                            }
                        />
                    </MATERIAL.ListItem>
                </>
            }
            {
                localStorage.config && JSON.parse(localStorage.config)['feeManager'] &&
                <>
                    <MATERIAL.Divider />
                    <MATERIAL.ListItem button key={`secondMenu-feeManager`} onClick={props.clickSecondary.bind(this, 'afbFeeSimulation')}>
                        <MATERIAL.ListItemText
                            primary={
                                <span className="font-indigo">{'Simulación y Cobro de Fees'}</span>
                            }
                        />
                    </MATERIAL.ListItem>
                </>
            }
        </MATERIAL.List>
    </MATERIAL.SwipeableDrawer>
}

export default SecondaryMenu;